export default {
  buttons: {
    reschedule: '배송 재조정',
    'reschedule-change-address': '배송 재조정/주소 변경',
    'add-time': '시간 추가',
  },
  'pickup-time-min-title': '픽업 시간 최소',
  'pickup-time-max-title': '픽업 시간 최대',
  'pickup-date': '배송 날짜 선택',
  'change-address': {
    title: '주소가 변경되었습니다',
    description: '주문 처리를 위해 잠시만 기다려 주세요. 추적 링크를 제공해 드리겠습니다.',
    error: '죄송합니다, 해당 주소로는 배송이 불가합니다. 다른 주소를 입력해 주세요.',
  },
  'coolbox-modal': {
    message: '귀하의 약품은 시간에 민감한 배송 제한이 있습니다.<br>배송 날짜를 재조정하시겠습니까?',
    rescheduleButton: '예, 재조정합니다',
    cancelButton: '취소',
  },
  'next-day-window': '익일 8:00am-9:00pm',
}
